<template>
  <div class="w-5/6 bg-white rounded-xl shadow mx-auto p-4">
    <h1 class="text-center">{{ name }}</h1>
    <hr class="my-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: ['name']
}
</script>

<style scoped>

</style>